export const paginationComponentOverrides = {
    MuiPagination: {
        defaultProps: {
            shape: 'rounded',
            siblingCount: 1,
            variant: 'outlined'
        }
    },
    MuiPaginationItem: {
        styleOverrides: {
            root: ({ theme }) => ({
                backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultBase,
                borderColor: theme.tokens.FuelColorBorderDark,
                borderRadius: theme.tokens.FuelBorderRadiusBase,
                color: theme.tokens.FuelColorTextTertiary,
                margin: `0px ${theme.tokens.FuelSpacing1}`,
                minWidth: '2.25rem',
                height: '2.25rem',
                fontSize: theme.tokens.FuelFontSizeSm,
                '&:hover': {
                    backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultHovered,
                    borderColor: theme.tokens.FuelColorBorderDark,
                    color: theme.tokens.FuelColorTextTertiary
                },
                '&:active': {
                    backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultPressed,
                    borderColor: theme.tokens.FuelColorBorderDark,
                    color: theme.tokens.FuelColorTextTertiary
                },
                '&.Mui-focusVisible': {
                    boxShadow: theme.tokens.FuelShadowFocused,
                    backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultBase
                },
                '&.Mui-selected': {
                    backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultSelected,
                    borderColor: theme.tokens.FuelColorBorderSelected,
                    color: theme.tokens.FuelColorBrandPrimary,
                    '&:hover': {
                        backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultSelected
                    }
                },
                '&.Mui-disabled': {
                    backgroundColor: theme.tokens.FuelColorBackgroundActionDefaultBase,
                    borderColor: theme.tokens.FuelColorBorderDark,
                    color: theme.tokens.FuelColorGray700,
                    opacity: '0.5',
                    pointerEvents: 'auto'
                }
            }),
            sizeSmall: ({ theme }) => ({
                minWidth: '2rem',
                height: '2rem',
                fontSize: theme.tokens.FuelFontSizeSm
            }),
            sizeLarge: ({ theme }) => ({
                minWidth: '2.5rem',
                height: '2.5rem',
                fontSize: theme.tokens.FuelFontSizeMd
            }),
            ellipsis: ({ theme }) => ({
                size: theme.tokens.FuelFontSizeXs,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'transparent',
                '&:hover': {
                    backgroundColor: 'transparent'
                }
            })
        }
    }
};
